import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-comments"
}
const _hoisted_2 = { class: "comment-item" }
const _hoisted_3 = { class: "comment-header" }
const _hoisted_4 = { class: "admin-info" }
const _hoisted_5 = { class: "comment-content" }
const _hoisted_6 = {
  key: 0,
  class: "status-change"
}
const _hoisted_7 = { class: "status-from" }
const _hoisted_8 = { class: "status-to" }

import { computed } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import { AdminComment } from '@/models/evCarProfile'
import { formatDateWithTime } from '@/helpers/date'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminCommentsSection',
  props: {
    comments: {}
  },
  setup(__props: any) {

const props = __props

const sortedComments = computed(() => {
  if (!props.comments || props.comments.length === 0) return []

  return [...props.comments].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  )
})

const formatDate = (dateString: string) => {
  return formatDateWithTime(dateString)
}

const formatAction = (action: string) => {
  switch (action) {
    case 'activated':
      return 'Activated'
    case 'deactivated':
      return 'Deactivated'
    case 'admin_activated':
      return 'Admin Activated'
    case 'admin_deactivated':
      return 'Admin Deactivated'
    case 'blocked':
      return 'Blocked'
    case 'unblocked':
      return 'Unblocked'
    case 'status_change':
      return 'Status Changed'
    case 'comment':
      return 'Comment'
    default:
      return action
  }
}

const getActionType = (action: string) => {
  switch (action) {
    case 'activated':
    case 'admin_activated':
    case 'unblocked':
      return 'success'
    case 'deactivated':
      return 'warning'
    case 'blocked':
    case 'admin_deactivated':
      return 'danger'
    case 'comment':
      return 'info'
    default:
      return 'primary'
  }
}

const getTimelineType = (action: string) => {
  switch (action) {
    case 'activated':
    case 'admin_activated':
    case 'unblocked':
      return 'success'
    case 'deactivated':
      return 'warning'
    case 'blocked':
    case 'admin_deactivated':
      return 'danger'
    case 'comment':
      return 'primary'
    default:
      return 'primary'
  }
}

const getStatusTagType = (status: string) => {
  switch (status) {
    case 'active':
      return 'success'
    case 'inactive':
      return 'warning'
    case 'admin_blocked':
      return 'danger'
    case 'admin_active':
      return 'success'
    case 'verifying':
      return 'info'
    default:
      return 'info'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "title" }, "Logs & Comments History", -1)),
    (!_ctx.comments || _ctx.comments.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "No logs or admin comments available", -1)
        ])))
      : (_openBlock(), _createBlock(_component_el_timeline, { key: 1 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedComments.value, (comment, index) => {
              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                timestamp: formatDate(comment.created_at),
                placement: "top",
                size: "large",
                type: getTimelineType(comment.action)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_tag, {
                        type: getActionType(comment.action),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(formatAction(comment.action)), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"]),
                      _createElementVNode("span", _hoisted_4, " Admin: " + _toDisplayString(comment.admin_email || comment.admin_id || 'System'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("p", null, [
                        _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Details:", -1)),
                        _createTextVNode(" " + _toDisplayString(comment.comment), 1)
                      ])
                    ]),
                    (comment.status_from && comment.status_to)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, [
                            _createVNode(_component_el_tag, {
                              size: "small",
                              type: "info"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(comment.status_from), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createVNode(_component_el_icon, { class: "arrow-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowRight))
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_8, [
                            _createVNode(_component_el_tag, {
                              size: "small",
                              type: getStatusTagType(comment.status_to)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(comment.status_to), 1)
                              ]),
                              _: 2
                            }, 1032, ["type"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["timestamp", "type"]))
            }), 128))
          ]),
          _: 1
        }))
  ], 64))
}
}

})